import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { storeKENNumber, storeSONumber, resetIOTData, setPendingToStartSurvey } from '../../application_actions';
import { Navigator } from '../presentational/navigator.jsx';
import { Input } from '../presentational/input.jsx';

import makeBasePage from '../base_page.jsx';

export class ValidateEquipment extends Component {

  constructor(props) {
    super(props);

    this.state = {
      KEN: (this.props.app.KEN || undefined)
    }
  }

  componentDidMount() {
    this.props.resetIOTData();
    this.initFlow()
    this.initKen();
  }

  initFlow(){
    if(!this.props.progress.flow || !this.props.progress.flow.length){
      if(this.props.location.pathname === '/site_survey/validate-equipment'){
        this.props.selectFlow('site_survey',0)
      }else{ 
        this.props.history.push('/main');
      }
    }
  }

  initKen() {
    const urlParamKen = new URLSearchParams(this.props.location.search).get('KEN');
    const urlParamServiceOrder = new URLSearchParams(this.props.location.search).get('SO');
    let ken = undefined
    if(urlParamKen) {
      ken = urlParamKen
    } else if(this.props.app.KEN) {
      ken = this.props.app.KEN
    }
    this.setState({
      KEN: (ken || undefined)
    });

    if (ken && urlParamServiceOrder) {
      this.storeServiceOrderNumber(ken, urlParamServiceOrder);
    }
  }

  storeServiceOrderNumber(ken, serviceOrder) {
    if (serviceOrder) {
      this.props.storeSONumber(serviceOrder);
    } else {
      this.props.storeSONumber('-');
    }
  }

  onKENChange(value) {
    this.setState({ KEN: value })
  }

  isContinueDisabled() {
    if(this.props.app.internetStatus){
      return this.state.KEN == undefined || this.state.KEN.length != 8
    }
    return true
  }

  submitData() {
    if(this.props.app.KEN !== this.state.KEN) this.props.setPendingToStartSurvey(undefined)
    this.props.storeKENNumber(this.state.KEN);
    this.storeServiceOrderNumber(this.state.KEN, this.props.app.SO);
    this.props.goForward();
  }

  render() {

    return (
      <div className="page-view" id="register-equipment">
        <h1>
          {this.props.strings.ValidateEquipment.enterEquipmentNumber}
        </h1>
        <div>
          <Input
            label={this.props.strings.KoneEquipment.KEN}
            onInputChange={(value) => this.onKENChange(value)}
            value={this.state.KEN || ''}
            minLength={8}
            maxLength={8}
            lengthText={this.props.strings.Common.digits}
            valid={ this.state.KEN !== undefined && this.state.KEN.length == 8 }
          />
        </div>
        <Navigator
          continueText={this.props.strings.ValidateEquipment.validateKEN}
          backText={this.props.strings.Common.back}
          onContinue={ () => this.submitData() }
          onBack={() => this.props.goBack() }
          continueDisabled={ this.isContinueDisabled() }
        />
      </div>
    );
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({ storeKENNumber, storeSONumber, resetIOTData, setPendingToStartSurvey }, dispatch);
}

export default connect(null, mapDispatchToProps)(makeBasePage('ValidateEquipment')(ValidateEquipment));
